import { Box, Collapse } from '@mui/material'
import React, { ReactNode } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material/styles'
import cc from 'classcat'
import { Typography } from '@mui/material'
import { useToggleState } from '../../../../lib/util/hooks'
import FlatCard from '../../../elements/FlatCard'
import Content from './Content'
import { MetricStatusType } from '../../../../types/Metrics'

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        padding: theme.spacing(1, 2),
        flexShrink: 0,
        borderRadius: 0,
    },
    compact: {
        cursor: 'default',
    },
    collapseContainer: {
        position: 'absolute',
        top: '100%',
        width: '100%',
    },
    collapseContent: {
        margin: -1,
        borderTop: 'none',
    },
    detail: {
        marginTop: theme.spacing(0.5),
    },
    locked: {
        backgroundColor: theme.palette.grey[50],
        borderWidth: 1,
        borderColor: theme.palette.grey[300],
    },
}))

interface CompactLayoutProps {
    label: string
    value: string
    compact: boolean
    delta?: number
    status?: MetricStatusType
    detail?: string
    content?: ReactNode
    children?: ReactNode
    locked?: boolean
}

const CompactLayout = ({ detail, compact = false, label, value, delta, status, content, children, locked }: CompactLayoutProps) => {
    const classes = useStyles()
    const [cardMenuVisible, showCardMenu, hideCardMenu] = useToggleState(false)

    return (
        // Explicit width is to prevent reflows when collapsing.
        <Box width={240} flexShrink={0} position="relative" onMouseEnter={showCardMenu} onMouseLeave={hideCardMenu}>
            {content ? content : <Content compact label={label} value={value} delta={delta} status={status} />}
            <div className={classes.collapseContainer}>
                <Collapse in={cardMenuVisible} timeout={150}>
                    <FlatCard classes={{ root: cc([classes.card, compact && classes.compact, locked && classes.locked, classes.collapseContent]) }}>
                        <Typography variant="body2" color="textSecondary" className={classes.detail}>
                            {detail}
                        </Typography>
                        {children}
                    </FlatCard>
                </Collapse>
            </div>
        </Box>
    )
}

export default CompactLayout